(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dw-home-nav"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',function(event){const link=event.target.closest('.dw-h-mobile-menu a');if(link){link.closest('details').open=false;}});
document.addEventListener('keydown',function(event){if(event.key==='Escape'){const menu=document.querySelector('.dw-shop-menu[open]')||document.querySelector('.dw-h-mobile-menu[open]');if(menu){menu.open=false;menu.querySelector('summary').focus();}}});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dw-shop-menu"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-dw-menu]').forEach(menu=>{const tabs=[...menu.querySelectorAll('[role=tab]')];const select=button=>{tabs.forEach(t=>{const active=t===button;t.setAttribute('aria-selected',String(active));t.tabIndex=active?0:-1;document.getElementById(t.getAttribute('aria-controls')).hidden=!active;});};tabs.forEach((button,index)=>{button.addEventListener('click',()=>select(button));button.addEventListener('pointerenter',e=>{if(e.pointerType==='mouse')select(button);});button.addEventListener('keydown',e=>{let next;if(e.key==='ArrowRight')next=(index+1)%tabs.length;if(e.key==='ArrowLeft')next=(index+tabs.length-1)%tabs.length;if(e.key==='Home')next=0;if(e.key==='End')next=tabs.length-1;if(next!==undefined){e.preventDefault();select(tabs[next]);tabs[next].focus();}});});document.addEventListener('click',e=>{if(!menu.contains(e.target))menu.open=false;});menu.addEventListener('focusout',e=>{if(!menu.contains(e.relatedTarget))menu.open=false;});});
  } catch(e) { console.error(e); }
})();

})();
